import { useGetMember } from '#api/member';
import { PATH } from '#const/path';
import { useChat } from '#providers/Chat';
import CoachMark from '#shared/CoachMark';
import { IGetConfirmationForm } from '#types/confirmationForms';
import { BsChatLeftDotsFill } from 'react-icons/bs';
import { useNavigate } from 'react-router';
import { Tab } from 'src/shared/components/tab/Tab';
import LectureCount from './LectureCount';
import TabbedNavigation from './TabbedNavigation';
import {
  Container,
  Container2,
  IconWrapper,
  NameText,
  StyledImage
} from './styles';
import TagManager from 'react-gtm-module';

interface Props {
  customerDetail: IGetConfirmationForm | Record<string, never>;
  type: 'customer-detail' | 'confirmation-form';
}

export const DashboardCustomerInfo = ({ customerDetail, type }: Props) => {
  const navigate = useNavigate();
  const { openChat } = useChat();
  const handleChatButtonClick = (customerId: string) => {
    const onSuccess = () => {
      navigate(PATH.CHAT_ROOM);
    };
    const onFail = () => '';
    openChat(customerId, onSuccess, onFail);
  };

  const personId = sessionStorage.getItem('personId') ?? '';
  const { data: member } = useGetMember(personId);

  const requestTab = {
    // '결제 요청': 'payment-request',
    '리뷰 요청': 'review-request'
  };

  function setProfileImage(): string {
    try {
      // 프로필의 첫 번째 항목에서 uploadedLink를 안전하게 접근합니다.
      if (customerDetail.person.profile[0].uploadedLink) {
        return customerDetail.person.profile[0].uploadedLink;
      } else {
        throw new Error('Uploaded link not found');
      }
    } catch (error) {
      // 예외가 발생했을 때 기본 이미지 URL을 반환합니다.
      return 'https://trainer.fibud.kr/images/sns-thumbnail.png';
    }
  }

  if (!member) return <div></div>;

  return (
    <>
      <CoachMark />
      <Container>
        <Container2>
          <StyledImage src={setProfileImage()}></StyledImage>
          <NameText>{member.name}</NameText>
          <IconWrapper>
            <BsChatLeftDotsFill
              onClick={() => handleChatButtonClick(member.personId)}
              style={{
                width: '20px', // 아이콘의 너비
                height: '20px', // 아이콘의 높이
                fill: 'var(--Gray-Scale-400, #BCB8C3)', // 색상 설정
                cursor: 'pointer' // 클릭 가능한 커서 설정
              }}
              cursor="pointer"
            />
          </IconWrapper>
        </Container2>
        <CoachMark.SpotLight style={{ borderRadius: '12px' }}>
          <CoachMark.Tooltip
            position="top"
            message={`현재 회원이 신청한 회차와 완료한 회차, \n 트레이너가 완성한 차트 수를 한 번에 보여줘요`}
          />
          <LectureCount />
        </CoachMark.SpotLight>

        <CoachMark.SpotLight style={{ padding: '8px', borderRadius: '12px' }}>
          <CoachMark.Tooltip
            position="bottom"
            message={`회원에게 리뷰 요청을 \n 카카오톡 알림으로 보낼 수 있어요`}
          />
          <Tab
            tab={requestTab}
            onClick={value => {
              if (value === 'review-request') {
                TagManager.dataLayer({
                  dataLayer: {
                    event: 'customer_reviewrequest_click',
                    category: '회원관리',
                    action: 'customer_reviewrequest_click',
                    value: 2
                  }
                });
              }
              navigate(`/dashboard/customer/${value}`);
            }}
          />
        </CoachMark.SpotLight>
      </Container>
      <TabbedNavigation />
    </>
  );
};
